<template><section><template>
<h3>选择框</h3>
<div class="bs-docs-section">
<div class="bs-example">
<blockquote>
<p>单选</p>
</blockquote>
  <p>
    <pre>
Select data : {{single}}
    </pre>
  </p>
  <n3-select v-model="single">
    <n3-option value="Apple">Apple</n3-option>
    <n3-option value="Banana">Banana</n3-option>
    <n3-option value="Cherry">Cherry</n3-option>
    <n3-option value="Orange">Orange</n3-option>
    <n3-option value="Grape">Grape</n3-option>
  </n3-select>
  <hr>
<blockquote>
<p>多选</p>
</blockquote>
  <p>
    <pre>
Select data : {{multiple.join(', ')}}
    </pre>
  </p>
  <n3-select multiple v-model="multiple" search="">
    <n3-option value="Apple">Apple</n3-option>
    <n3-option value="Banana">Banana</n3-option>
    <n3-option value="Cherry">Cherry</n3-option>
    <n3-option value="Orange">Orange</n3-option>
    <n3-option value="Grape">Grape</n3-option>
  </n3-select>
  <hr>
<blockquote>
<p>多选限制</p>
</blockquote>
  <p>
    <pre>
Select data : {{multipleLimit.join(', ')}}
    </pre>
  </p>
  <n3-select multiple :limit="2" v-model="multipleLimit" search="" extra="">
    <n3-option value="Apple">Apple</n3-option>
    <n3-option value="Banana">Banana</n3-option>
    <n3-option value="Cherry">Cherry</n3-option>
    <n3-option value="Orange">Orange</n3-option>
    <n3-option value="Grape">Grape</n3-option>
  </n3-select>
  <hr>
<blockquote>
<p>自定义内容</p>
</blockquote>
  <p>
    <pre>
Select data : {{custom.join(', ')}}
    </pre>
  </p>
  <n3-select multiple v-model="custom">
    <n3-option value="Star"><span class="n3-fa n3-fa-star"></span> Star</n3-option>
    <n3-option value="Heart"><span class="n3-fa n3-fa-heart"></span> Heart</n3-option>
    <n3-option value="Film"><span class="n3-fa n3-fa-film"></span> Film</n3-option>
    <n3-option value="Inbox"><span class="n3-fa n3-fa-inbox"></span> Inbox</n3-option>
  </n3-select>
  <hr>
<blockquote>
<p>传递数组，支持搜索</p>
</blockquote>
  <p>
    支持只传递接json数组，可以支持搜索
    <pre>
Select data : {{arr}}
    </pre>
  </p>
  <n3-select v-model="arr" :options="fruitOptions" :search="true" multiple extra="" width="200px">
  </n3-select>
</div>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-comment">&lt;!-- 单选框 --&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">n3-select</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"single"</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-option</span> <span class="hljs-attr">value</span>=<span class="hljs-string">"Apple"</span>&gt;</span>Apple<span class="hljs-tag">&lt;/<span class="hljs-name">n3-option</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-option</span> <span class="hljs-attr">value</span>=<span class="hljs-string">"Banana"</span>&gt;</span>Banana<span class="hljs-tag">&lt;/<span class="hljs-name">n3-option</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-option</span> <span class="hljs-attr">value</span>=<span class="hljs-string">"Cherry"</span>&gt;</span>Cherry<span class="hljs-tag">&lt;/<span class="hljs-name">n3-option</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-option</span> <span class="hljs-attr">value</span>=<span class="hljs-string">"Orange"</span>&gt;</span>Orange<span class="hljs-tag">&lt;/<span class="hljs-name">n3-option</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-option</span> <span class="hljs-attr">value</span>=<span class="hljs-string">"Grape"</span>&gt;</span>Grape<span class="hljs-tag">&lt;/<span class="hljs-name">n3-option</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">n3-select</span>&gt;</span>

<span class="hljs-comment">&lt;!-- 多选框 --&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">n3-select</span> <span class="hljs-attr">multiple</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"multiple"</span> <span class="hljs-attr">search</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-option</span> <span class="hljs-attr">value</span>=<span class="hljs-string">"Apple"</span>&gt;</span>Apple<span class="hljs-tag">&lt;/<span class="hljs-name">n3-option</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-option</span> <span class="hljs-attr">value</span>=<span class="hljs-string">"Banana"</span>&gt;</span>Banana<span class="hljs-tag">&lt;/<span class="hljs-name">n3-option</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-option</span> <span class="hljs-attr">value</span>=<span class="hljs-string">"Cherry"</span>&gt;</span>Cherry<span class="hljs-tag">&lt;/<span class="hljs-name">n3-option</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-option</span> <span class="hljs-attr">value</span>=<span class="hljs-string">"Orange"</span>&gt;</span>Orange<span class="hljs-tag">&lt;/<span class="hljs-name">n3-option</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-option</span> <span class="hljs-attr">value</span>=<span class="hljs-string">"Grape"</span>&gt;</span>Grape<span class="hljs-tag">&lt;/<span class="hljs-name">n3-option</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">n3-select</span>&gt;</span>

<span class="hljs-comment">&lt;!-- 多选限制 --&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">n3-select</span> <span class="hljs-attr">multiple</span> <span class="hljs-attr">:limit</span>=<span class="hljs-string">"2"</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"multipleLimit"</span> <span class="hljs-attr">search</span> <span class="hljs-attr">extra</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-option</span> <span class="hljs-attr">value</span>=<span class="hljs-string">"Apple"</span>&gt;</span>Apple<span class="hljs-tag">&lt;/<span class="hljs-name">n3-option</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-option</span> <span class="hljs-attr">value</span>=<span class="hljs-string">"Banana"</span>&gt;</span>Banana<span class="hljs-tag">&lt;/<span class="hljs-name">n3-option</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-option</span> <span class="hljs-attr">value</span>=<span class="hljs-string">"Cherry"</span>&gt;</span>Cherry<span class="hljs-tag">&lt;/<span class="hljs-name">n3-option</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-option</span> <span class="hljs-attr">value</span>=<span class="hljs-string">"Orange"</span>&gt;</span>Orange<span class="hljs-tag">&lt;/<span class="hljs-name">n3-option</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-option</span> <span class="hljs-attr">value</span>=<span class="hljs-string">"Grape"</span>&gt;</span>Grape<span class="hljs-tag">&lt;/<span class="hljs-name">n3-option</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">n3-select</span>&gt;</span>

<span class="hljs-comment">&lt;!-- 自定义内容 --&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">n3-select</span> <span class="hljs-attr">multiple</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"custom"</span> &gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-option</span> <span class="hljs-attr">value</span>=<span class="hljs-string">"Star"</span>&gt;</span><span class="hljs-tag">&lt;<span class="hljs-name">span</span>  <span class="hljs-attr">class</span>=<span class="hljs-string">"n3-fa n3-fa-star"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">span</span>&gt;</span> Star<span class="hljs-tag">&lt;/<span class="hljs-name">n3-option</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-option</span> <span class="hljs-attr">value</span>=<span class="hljs-string">"Heart"</span>&gt;</span><span class="hljs-tag">&lt;<span class="hljs-name">span</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"n3-fa n3-fa-heart"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">span</span>&gt;</span> Heart<span class="hljs-tag">&lt;/<span class="hljs-name">n3-option</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-option</span> <span class="hljs-attr">value</span>=<span class="hljs-string">"Film"</span>&gt;</span><span class="hljs-tag">&lt;<span class="hljs-name">span</span>  <span class="hljs-attr">class</span>=<span class="hljs-string">"n3-fa n3-fa-film"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">span</span>&gt;</span> Film<span class="hljs-tag">&lt;/<span class="hljs-name">n3-option</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-option</span> <span class="hljs-attr">value</span>=<span class="hljs-string">"Inbox"</span>&gt;</span><span class="hljs-tag">&lt;<span class="hljs-name">span</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"n3-fa n3-fa-inbox"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">span</span>&gt;</span> Inbox<span class="hljs-tag">&lt;/<span class="hljs-name">n3-option</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">n3-select</span>&gt;</span>

<span class="hljs-comment">&lt;!-- 传递数组，支持搜索 --&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">n3-select</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"arr"</span> <span class="hljs-attr">:options</span>=<span class="hljs-string">"fruitOptions"</span> <span class="hljs-attr">:search</span>=<span class="hljs-string">"true"</span> <span class="hljs-attr">multiple</span> <span class="hljs-attr">extra</span> <span class="hljs-attr">width</span>=<span class="hljs-string">"400px"</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">n3-select</span>&gt;</span>

</code></pre>
<pre v-pre=""><code v-pre="" class="language-javascript"><span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  data () {
    <span class="hljs-keyword">return</span> {
      <span class="hljs-attr">fruitOptions</span>: [
        {<span class="hljs-attr">value</span>: <span class="hljs-string">'apple'</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">'Apple'</span>},
        {<span class="hljs-attr">value</span>: <span class="hljs-string">'banana'</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">'Banana'</span>},
        {<span class="hljs-attr">value</span>: <span class="hljs-string">'cherry'</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">'Cherry'</span>},
        {<span class="hljs-attr">value</span>: <span class="hljs-string">'orange'</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">'Orange'</span>},
        {<span class="hljs-attr">value</span>: <span class="hljs-string">'grape'</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">'Grape'</span>}
      ],
      <span class="hljs-attr">arr</span>: [<span class="hljs-string">'apple'</span>, <span class="hljs-string">'banana'</span>],
      <span class="hljs-attr">single</span>: <span class="hljs-string">'Apple'</span>,
      <span class="hljs-attr">multiple</span>: [],
      <span class="hljs-attr">multipleLimit</span>: [],
      <span class="hljs-attr">custom</span>: []
    }
  }
}
</code></pre>
<h3>参数</h3>
<p>样式的参数和 <a href="#n3ButtonsDocs">按钮</a> 相同</p>
<table>
<thead>
<tr>
<th>参数名</th>
<th>类型</th>
<th>默认值</th>
<th>说明</th>
</tr>
</thead>
<tbody>
<tr>
<td>value</td>
<td></td>
<td></td>
<td>多选为数组，单选为单个数字或者字符串</td>
</tr>
<tr>
<td>options</td>
<td><code v-pre="">Array</code></td>
<td><code v-pre="">[]</code></td>
<td></td>
</tr>
<tr>
<td>placeholder</td>
<td><code v-pre="">String</code></td>
<td>''</td>
<td></td>
</tr>
<tr>
<td>multiple</td>
<td><code v-pre="">Boolean</code></td>
<td><code v-pre="">false</code></td>
<td>支持多选</td>
</tr>
<tr>
<td>limit</td>
<td><code v-pre="">Number</code></td>
<td><code v-pre="">1024</code></td>
<td>多选限制</td>
</tr>
<tr>
<td>search</td>
<td><code v-pre="">Boolean</code></td>
<td><code v-pre="">false</code></td>
<td>是否支持搜索</td>
</tr>
<tr>
<td>extra</td>
<td><code v-pre="">Boolean</code></td>
<td><code v-pre="">false</code></td>
<td>可支持在输入款内添加新的选项(需要search支持)</td>
</tr>
<tr>
<td>input-placeholder</td>
<td><code v-pre="">String</code></td>
<td>``</td>
<td>输入框的placeholder</td>
</tr>
<tr>
<td>width</td>
<td><code v-pre="">String</code></td>
<td></td>
<td>选择框大小</td>
</tr>
<tr>
<td>menu-max-height</td>
<td><code v-pre="">String</code></td>
<td>300px</td>
<td>下拉框最大高度</td>
</tr>
<tr>
<td>menu-width</td>
<td><code v-pre="">String</code></td>
<td></td>
<td>下拉框宽度</td>
</tr>
<tr>
<td>format</td>
<td><code v-pre="">Function</code></td>
<td><code v-pre="">function(item){ return item.label }</code></td>
<td>选中内容的格式化显示</td>
</tr>
<tr>
<td>disabled</td>
<td><code v-pre="">Boolean</code></td>
<td><code v-pre="">false</code></td>
<td></td>
</tr>
<tr>
<td>readonly</td>
<td><code v-pre="">Boolean</code></td>
<td><code v-pre="">false</code></td>
<td></td>
</tr>
<tr>
<td>cancelled</td>
<td><code v-pre="">Boolean</code></td>
<td></td>
<td>单选时，是否可撤销</td>
</tr>
<tr>
<td>match-case</td>
<td><code v-pre="">Boolean</code></td>
<td></td>
<td>搜索过滤，大小写敏感控制</td>
</tr>
</tbody>
</table>
<h3>事件</h3>
<table>
<thead>
<tr>
<th>名称</th>
<th>说明</th>
<th>参数</th>
</tr>
</thead>
<tbody>
<tr>
<td>change</td>
<td>值变化</td>
<td>(currentValue)</td>
</tr>
</tbody>
</table>
<p>其他表单相关参数，请移步 <a href="#n3FormDocs">表单验证</a> 待验证组件参数</p>
</div>
</template>

</section></template>

<script>
export default {
  data () {
    return {
      fruitOptions: [
        {value: 'apple', label: 'Apple'},
        {value: 'banana', label: 'Banana'},
        {value: 'cherry', label: 'Cherry'},
        {value: 'orange', label: 'Orange'},
        {value: 'grape', label: 'Grape'}
      ],
      arr: ['apple', 'banana'],
      single: 'Apple',
      multiple: [],
      multipleLimit: [],
      custom: []
    }
  }
}
</script>


// WEBPACK FOOTER //
// n3SelectDocs.md?6638942d